import { COLORS } from '../constants'

export const lightTheme = {
  colors: COLORS,
  // outras configurações específicas do tema claro
};